import React from "react";

const DashBoard = () => {
    return (
        <>
            <h1 className="">DashBoard</h1>
            <ul>
                <li>
                    <a href="https://cowlesdevelopmenthelp.nsplindia.co.in/tablet/home.htm" target="_blank" rel="noopener noreferrer">
                        Cowels Development Help
                    </a>
                </li>
            </ul>
        </>
    )
}

export default DashBoard;